import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = 'admin_nouveautes_vu';

// Iter 646 (Kamel) — 🆕 suivre en direct les changements livrés dans l'admin (preview comme prod).
export default function NouveautesBtn({ getAuthConfig }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const vu = parseInt(localStorage.getItem(KEY) || '0', 10);
  useEffect(() => { axios.get(`${API}/admin/nouveautes`, getAuthConfig()).then(r => setData(r.data)).catch(() => {}); }, [getAuthConfig]);
  if (!data) return null;
  const nouvelles = data.nouveautes.filter(n => n.iter > vu).length;
  const ouvrir = () => { setOpen(o => !o); localStorage.setItem(KEY, String(data.derniere)); };
  return (
    <span className="relative">
      <button onClick={ouvrir} className="text-xs font-bold px-2.5 py-1 rounded-full bg-sky-50 text-sky-900 border border-sky-200" title="Ce qui a changé récemment dans l'application" data-testid="admin-nouveautes-btn">
        🆕 Nouveautés{nouvelles > 0 && <span className="ml-1 px-1.5 rounded-full bg-red-600 text-white text-[10px]" data-testid="admin-nouveautes-badge">{nouvelles}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-[min(92vw,640px)] max-h-[70vh] overflow-y-auto bg-white border-2 border-sky-200 rounded-2xl shadow-xl z-50 p-3 text-left" data-testid="admin-nouveautes-panel">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm font-bold text-[#1E3A5F]">🆕 Les 10 dernières nouveautés</p>
            <button onClick={() => setOpen(false)} className="text-gray-500 font-bold" data-testid="admin-nouveautes-fermer">✕</button>
          </div>
          <p className="text-[11px] text-gray-500 mb-2">{window.location.hostname.includes('preview') ? '🧪 Tu es sur la PRÉVISUALISATION : ces changements sont testables ici avant déploiement.' : '🚀 Version déployée en production.'}</p>
          <ul className="space-y-2">
            {data.nouveautes.map(n => (
              <li key={n.iter} className={`text-xs rounded-lg px-2.5 py-2 border ${n.iter > vu ? 'bg-amber-50 border-amber-200' : 'bg-gray-50 border-gray-100'}`} data-testid={`nouveaute-${n.iter}`}>
                <span className="font-bold text-[#1E3A5F]">{n.titre || `#${n.iter}`}</span> <span className="text-gray-400">· {n.date}</span>{n.iter > vu && <span className="ml-1 text-[10px] font-bold text-amber-800">nouveau</span>}
                <p className="text-gray-700 mt-0.5 leading-snug">{n.texte}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </span>
  );
}
